import React from 'react'
import { Link } from 'react-router-dom'
import { Typography } from 'antd'
import { HistoryOutlined } from '@ant-design/icons'
import useRecent from '../../hooks/useRecent'
import { EntityKind, entityPath } from '../../routes'
import { kindLabels } from '../../sections'
const { Text } = Typography

interface RecentChipsProps {
    kinds: EntityKind[]
    // Usually the id that is already open
    exclude?: string
    // Prefix each chip with its kind when several kinds are mixed
    showKind?: boolean
}

const RecentChips: React.FC<RecentChipsProps> = ({ kinds, exclude, showKind }) => {
    const entries = useRecent(kinds).filter((entry) => entry.id !== exclude)
    if (entries.length === 0) return null

    return (
        <div className="recent-chips">
            <Text type="secondary" className="recent-chips-label">
                <HistoryOutlined /> Recent
            </Text>
            {entries.map((entry) => (
                <Link
                    key={`${entry.kind}:${entry.id}`}
                    to={entityPath(entry.kind, entry.id)}
                    className="recent-chip"
                    title={entry.label ? `${entry.id} · ${entry.label}` : entry.id}
                >
                    {showKind && <span className="recent-chip-kind">{kindLabels[entry.kind]}</span>}
                    {entry.id}
                </Link>
            ))}
        </div>
    )
}

export default RecentChips
